"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transactionDetailsPdf = void 0;
const store_1 = require("client/modules/orders/store");
const moment = require("moment-timezone");
const store_2 = require("../../../../../../users/store");
const mobx_1 = require("mobx");
const getErxLogs = async (claimId) => {
    const result = await store_1.ordersStore.readERXLog(claimId);
    const erxLogs = result.value;
    if (!!erxLogs && !!erxLogs.length) {
        return [
            { style: "erxHeader", text: "Raw Data" },
            {
                margin: [0, 10],
                text: [
                    { style: "erxSubheader", text: "Sent: " },
                    { style: "erxBody", text: cleanErxLogs(erxLogs, true) }
                ]
            },
            {
                text: [
                    { style: "erxSubheader", text: "Received: " },
                    { style: "erxBody", text: cleanErxLogs(erxLogs, false) }
                ]
            }
        ];
    }
    return [];
};
const cleanErxLogs = (erxLogs, isRequest) => erxLogs
    .filter(x => !!x.outgoing === isRequest)
    .sort(x => x.id)
    .map(x => x.payload.replace(/\s+/g, " ").replace(/[^\w\s\d{}]/g, ""))
    .join("\n\n");
/**
 *
 * Import and use this function to generate and download a pdf of the transaction details for a claim
 *
 * @param claim - standard claim object/IClaim
 *
 * Potential future extension: just generate the document definition and have a separate function containing metadata / header and footer
 *  information. This way we can generate larger documents for specific purposes that contain multiple pieces/subreports within.
 *
 */
// E-084 added "type" in the parameter
exports.transactionDetailsPdf = async (claim, type) => {
    var _a, _b, _c, _d;
    const { order } = claim;
    const { site } = order;
    const currentUser = store_2.usersStore.user.value;
    const erxLogs = await getErxLogs((_a = claim.claimId) !== null && _a !== void 0 ? _a : claim.id);
    const hasCopay = !!claim.copay;
    // These object's type definitions don't account for the fact that they can be nested. This coerces them into standard JS objects.
    const copayRequests = hasCopay
        ? JSON.parse(JSON.stringify(claim.copay.requests))
        : [];
    const copayResponses = hasCopay
        ? JSON.parse(JSON.stringify(claim.copay.responses))
        : [];
    const requests = JSON.parse(JSON.stringify(claim.requests));
    const responses = JSON.parse(JSON.stringify(claim.responses));
    const lastRequest = requests.length - 1;
    const rxFromRequest = (_d = (_c = (_b = requests[lastRequest].groups) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.claim) === null || _d === void 0 ? void 0 : _d.referenceNumber;
    const { header: firstRequestHeader, patient } = requests[0];
    const pdf = {
        content: [
            {
                alignment: "center",
                style: "header",
                text: "Claim Transaction Details"
            },
            {
                columns: [
                    { text: " ", width: "*" },
                    {
                        margin: [0, 10, 0, 50],
                        table: {
                            body: [
                                [
                                    {
                                        alignment: "center",
                                        style: "subHeader",
                                        text: "Claim Information"
                                    }
                                ],
                                [
                                    {
                                        layout: "noBorders",
                                        table: {
                                            body: [
                                                // [
                                                //   {
                                                //     style: "generalInfoKey",
                                                //     text: "Created Date:"
                                                //   },
                                                //   moment
                                                //     .tz(claim.date, site.timezone)
                                                //     .format("MM/DD/YYYY HH:mm:SS")
                                                // ], //B-096.3
                                                [{ style: "generalInfoKey", text: "Site:" }, site.name],
                                                [
                                                    { style: "generalInfoKey", text: "Patient:" },
                                                    `${patient.lastname.trim()}, ${patient.firstname.trim()}`
                                                ],
                                                [
                                                    {
                                                        style: "generalInfoKey",
                                                        text: "Date of Service:"
                                                    },
                                                    moment
                                                        .tz(responses[0].serviceDate, site.timezone)
                                                        .format("MMM DD, YYYY")
                                                ],
                                                [
                                                    { style: "generalInfoKey", text: "Rx Number:" },
                                                    rxFromRequest !== null && rxFromRequest !== void 0 ? rxFromRequest : claim.rxId.rxId
                                                ],
                                                [
                                                    {
                                                        style: "generalInfoKey",
                                                        text: "Insurance BIN"
                                                    },
                                                    firstRequestHeader.binNumber
                                                ],
                                                [
                                                    {
                                                        style: "generalInfoKey",
                                                        text: "Reporting PCN"
                                                    },
                                                    firstRequestHeader.processorNumber
                                                ]
                                                // The provided example NCPDP report includes 'Routing' and 'Duration',
                                                //    but I do not know where to get/if we have that information
                                            ],
                                            widths: ["auto", "auto"]
                                        }
                                    }
                                ]
                            ],
                            headerRows: 1
                        },
                        width: "auto"
                    },
                    { text: " ", width: "*" }
                ]
            },
            {
                margin: [5, 0],
                table: {
                    body: [
                        [
                            { style: "tableHeader", text: "Description" },
                            { style: "tableHeader", text: "Sent Value" },
                            { style: "tableHeader", text: "Description" },
                            { style: "tableHeader", text: "Received Value" }
                        ],
                        [
                            {
                                colSpan: 2,
                                layout: "noBorders",
                                table: {
                                    body: [
                                        ...formatTransactionData(requests, "claim"),
                                        ...formatTransactionData(copayRequests, "copay")
                                    ],
                                    widths: ["50%", "50%"]
                                }
                            },
                            {},
                            {
                                colSpan: 2,
                                layout: "noBorders",
                                table: {
                                    body: [
                                        ...formatTransactionData(responses, "claim"),
                                        ...formatTransactionData(copayResponses, "copay")
                                    ],
                                    widths: ["50%", "50%"]
                                }
                            },
                            {}
                        ]
                    ],
                    headerRows: 1,
                    widths: ["25%", "25%", "25%", "25%"]
                },
                width: "*"
            },
            {
                alignment: "center",
                stack: erxLogs,
                unbreakable: true
            }
        ],
        footer: (currentPage, pageCount) => ({
            columns: [
                {
                    alignment: "left",
                    text: `\u00A9 The Med Portal ${moment().format("YYYY")}`
                },
                { alignment: "right", text: `${currentPage} of ${pageCount}` }
            ],
            fontSize: 11,
            margin: [20, 10]
        }),
        header: {
            columns: [
                {
                    alignment: "left",
                    text: `Reporting User: ${currentUser.firstName} ${currentUser.lastName}`
                },
                {
                    alignment: "right",
                    text: `Print Date: ${moment().format("MM-DD-YYYY")}`
                }
            ],
            fontSize: 9,
            margin: [35, 15]
        },
        info: {
            title: `Claim_${claim.rxId.rxId}_${moment().format("MM-DD-YYYY")}`
        },
        styles: {
            erxBody: {
                fontSize: 10
            },
            erxHeader: {
                bold: true,
                fontSize: 12,
                margin: [0, 15, 0, 0]
            },
            erxSubheader: {
                bold: true,
                fontSize: 10
            },
            generalInfoKey: {
                alignment: "right",
                bold: true
            },
            header: {
                bold: true,
                fontSize: 18,
                margin: [0, 0, 0, 10]
            },
            subheader: {
                bold: true,
                fontSize: 16,
                margin: [0, 10, 0, 5]
            },
            tableExample: {
                margin: [0, 5, 0, 15]
            },
            tableHeader: {
                bold: true,
                color: "black",
                fontSize: 13,
                margin: [0, 5]
            },
            transactionContents: {
                fontSize: 10
            }
        }
    };
    // E-084 check the type of does not include reversal and erx report 
    if (type != 'reversalErxReport') {
        // @ts-ignore - pdfMake is mounted on the Window object by a <script> tag in index.html
        window.pdfMake
            .createPdf(pdf)
            .download(`Claim_${claim.rxId.rxId}_${moment().format("MM-DD-YYYY")}`);
    }
    // @ts-ignore - pdfMake is mounted on the Window object by a <script> tag in index.html
    return pdfMake.createPdf(pdf);
};
const normalizeCommaSpace = (str) => str.replace(/,(?=[^\s])/g, ", ");
const breakLongWords = (str, maxLength = 10) => {
    if (str.length > maxLength) {
        return str
            .slice(0, maxLength)
            .concat("\n")
            .concat(breakLongWords(str.slice(maxLength), maxLength));
    }
    return str;
};
const normalizeLongWords = (str) => {
    const re = /(\w,?)+/g;
    const words = str.match(re);
    if (!words) {
        return str;
    }
    return words.map(str => breakLongWords(str, 20)).join(" ");
};
const normalizeData = (str) => normalizeLongWords(normalizeCommaSpace(str.trim()));
const formatTransactionData = (transactions, tag) => _flattenArrays(transactions.map((transaction, i) => [
    [
        {
            alignment: "center",
            bold: true,
            colSpan: 2,
            text: `${tag === "copay" ? "Copay " : ""}Transaction #${i + 1}`
        },
        {}
    ],
    ...pdfDataMap(transaction)
]));
const pdfDataMap = (data, isPrice = false) => _flattenArrays(Object.keys(data).map((key, i) => {
    if (typeof data[key] === "string") {
        return [
            [
                {
                    bold: true,
                    style: "transactionContents",
                    text: key.slice(0, 1).toUpperCase() +
                        key.slice(1).replace(/([a-z])([A-Z])/g, "$1 $2")
                },
                {
                    style: "transactionContents",
                    text: isPrice
                        ? data[key]
                            .trim()
                            .replace(/^(\d*)([{ABCDEFGHI]){1,}$/, (match, p1, p2) => `$${(Number(p1 + erxDelimiterMap[p2]) / 100).toFixed(2)}`)
                        : normalizeData(data[key])
                }
            ]
        ];
    }
    if (Array.isArray(mobx_1.toJS(data[key]))) {
        return pdfDataMap(data[key][0], key.toLowerCase() === "pricing");
    }
    return [
        [
            {
                alignment: "center",
                bold: true,
                fontSize: 8,
                margin: [0, 5],
                text: `${key.toUpperCase()} SEGMENT`
            },
            {}
        ],
        ...pdfDataMap(data[key], key.toLowerCase() === "pricing")
    ];
}));
const _flattenArrays = (nestedArray) => [].concat.apply([], nestedArray);
const erxDelimiterMap = {
    "A": "1",
    "B": "2",
    "C": "3",
    "D": "4",
    "E": "5",
    "F": "6",
    "G": "7",
    "H": "8",
    "I": "9",
    "{": "0"
};



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-detail/components/order-claims/transaction-details/transaction-details-export.tsx
// module id = 3759
// module chunks = 0